import { Fragment } from 'react'

import {
  Box, NavigationLinkGroup, NestedNavigation, SelectBox, Text,
} from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'

import type { AgencyModel } from '@models/types'

import generateNavigationItems from './utils/generateNavigationItems'

const AccountingNavigation = () => {
  const agencySelectorPayload = useAgencySelector()

  const {
    callbacks: { selectAgencyId },
    hasMultipleAgencies,
    selectedAgencyId,
    sortedAgencies,
  } = agencySelectorPayload

  // @ts-expect-error TS2345
  const navigationItems = generateNavigationItems(selectedAgencyId)

  return (
    <NestedNavigation>
      <Box flexDirection="column" flexShrink={0}>
        <Box
          alignItems="center"
          height={190}
          justifyContent="center"
          padding="large"
          borderBottom="1px solid"
          borderColor="lineColor"
        >
          <Text fontSize="large">ACCOUNTING</Text>
        </Box>

        {hasMultipleAgencies && (
          <Box alignItems="center" borderBottom="1px solid" borderColor="lineColor" padding="large">
            <SelectBox
              callbacks={{ selectItem: (item: { key: number | string }) => selectAgencyId(item.key) }}
              items={sortedAgencies.map((agency: AgencyModel) => ({
                key: agency.id,
                title: agency.short_name || agency.title,
              }))}
              selectedItemKey={selectedAgencyId}
            />
          </Box>
        )}

        <Box flexDirection="column" padding="large">
          {navigationItems.sections?.map(section => (
            <Fragment key={section.key}>
              {section.title && <NestedNavigation.SectionHeader title={section.title} />}

              {section.items?.map(item => (
                <NavigationLinkGroup key={item.key} link={item} secondaryNav sidebarMaximized />
              ))}
            </Fragment>
          ))}
        </Box>
      </Box>
    </NestedNavigation>
  )
}

export default AccountingNavigation
